module.exports = __webpack_public_path__ + "img/linanbanner2.8cd224a4.jpg";